import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { BatchingRules } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';

export class BatchingRuleTypesEndpoints {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);

  get() {
    return this.http.get<BatchingRules.BatchingRuleTypesDefinitions>(`${this.env.constants.ADMIN_API_URL}/admin/batches/ruletypes`);
  }
}
